<template>
  <div class="confirm-delete-overlay" @click.self="$emit('cancel')">
    <div class="confirm-delete-card">
      <button class="confirm-delete-close" @click="$emit('cancel')">
        &times;
      </button>
      <div class="confirm-delete-icon">
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
          <path d="M12 2L1 21h22L12 2z" fill="#FFF3E0" stroke="#F57C00" stroke-width="1.5"/>
          <text x="12" y="17" text-anchor="middle" font-size="12" font-weight="bold" fill="#F57C00">!</text>
        </svg>
      </div>
      <p class="confirm-delete-message">{{ message }}</p>
      <button class="confirm-delete-yes" @click="$emit('confirm')">
        Yes
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmDeleteDialog',
  emits: ['confirm', 'cancel'],
  props: {
    message: {
      type: String,
      default: 'Are you sure you want to delete?',
    },
  },
};
</script>

<style scoped>
.confirm-delete-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.35);
}

.confirm-delete-card {
  position: relative;
  background: #fff;
  border-radius: 12px;
  padding: 32px 24px 24px;
  width: 260px;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
}

.confirm-delete-close {
  position: absolute;
  top: 12px;
  right: 14px;
  border: none;
  background: none;
  font-size: 22px;
  color: #999;
  cursor: pointer;
  line-height: 1;
  padding: 0;
}

.confirm-delete-close:hover {
  color: #333;
}

.confirm-delete-icon {
  margin-bottom: 16px;
}

.confirm-delete-message {
  font-size: 15px;
  color: #333;
  margin: 0 0 20px;
  line-height: 1.4;
}

.confirm-delete-yes {
  display: inline-block;
  min-width: 100px;
  padding: 10px 28px;
  border: none;
  border-radius: 6px;
  background: #409EFF;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}

.confirm-delete-yes:active {
  background: #3080e0;
}
</style>
